import {
  CannectScience,
  IconeAjuda,
  IconeCarrinho,
  IconeCartao,
  IconeCasa,
  IconeNovaConsulta,
  IconePacote,
  IconePerfilPaciente,
  IconePessoa,
  IconeReceita
} from 'assets/svg'

export const PATH_SELECTOR_ICONS = {
  home: <IconeCasa />,
  cart: <IconeCarrinho />,
  profile: <IconePerfilPaciente />,
  patients: <IconePessoa />,
  orders: <IconePacote />,
  prescription: <IconeReceita />,
  consult: <IconeNovaConsulta />,
  card: <IconeCartao />,
  address: <IconeCasa />,
  help: <IconeAjuda />,
  science: <CannectScience />
}
